/* eslint-disable unicorn/new-for-builtins */

import { styled } from '@linaria/react';
import Image from 'next/image';

const Container = styled.div`
  display: flex;
  column-gap: 6px;
  margin-right: 14px;
  align-items: center;
`;

type HotRateProps = {
  hotRank: number;
};

const HotRate = ({ hotRank }: HotRateProps) => {
  const hotRate = getHotRate(hotRank);

  return (
    <Container>
      {[...Array(hotRate)].map((_, index) => (
        <Image key={index} width={18} height={18} src='/assets/icons/symbol-icon-hot.svg' alt='' />
      ))}
    </Container>
  );
};

export default HotRate;

const HOT_RATE_THRESHOLDS = [
  { threshold: 100, rate: 3 },
  { threshold: 50, rate: 2 },
  { threshold: 0, rate: 1 }
];

const getHotRate = (hotRank: number): number => {
  return HOT_RATE_THRESHOLDS.find(({ threshold }) => hotRank >= threshold)?.rate ?? 1;
};
